module.exports = __webpack_public_path__ + "img/2017_L.dd46b434.png";